import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';

// services
import { ErrorHandler } from "../../../services/error-handler.service";
// models
import { ModalData } from "../../../models/modal.interface";
import { Store } from '@ngrx/store';
import { AppState } from 'app/booking/models/app-state.interface';
import { take } from 'rxjs/operators';
import { EventsService } from '../../../../booking/services/events.service';
@Component({
  selector: 'app-modal-time-slot-expired',
  templateUrl: './modal-time-slot-expired.component.html',
  styleUrls: ['./modal-time-slot-expired.component.scss']
})
export class ModalTimeSlotExpiredComponent implements OnInit {

  @Input()
  modalData: ModalData;

  public modalList: Array<any> = [];

  constructor(
    private _errorService: ErrorHandler,
    private _appStore: Store<AppState>,
    private _eventsService: EventsService,
    @Inject(PLATFORM_ID) public platformId: Object,
  ) { }

  ngOnInit(): void {

  }
  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }
  selectTimeSlotHandler() {
    
    const params = window.location.pathname.slice(1,4);
    const d2dService = params === 'abc' ? 'delivery-time' : 'collection-time';

    if(this.getState(this._appStore).bookingReducer.bookingDetails.isD2dService) {
      this._eventsService.goToBookingSwitcher(params === 'abc' ? 'ccd' : 'abc', d2dService, null, 'falseD2D');
    }else {
      this._eventsService.goToPanel('prev');
    }

    this.close();
  }
  close() {
    this._errorService.modalItem$.next("remove");
  }

}
